<template>
  <div class="kbbb" v-if="kbxmlc">
    <template v-if='qrjssj&& role == "Z"'>
      <div class="bjBtn">
        <div class="clear">
          <div class='clockBox'>
            <p class='time'>确认剩余时间</p>
            <myClock
             class='lf'
              :shenyu="qrjssj"
              :key="qrjssj"
              cId="c1"
            ></myClock>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div :class="['box', kbxmlc.zt == '2' || role != 'Z' ? 'noBtn' : '']">
        <div class="clear">
          <p class="cont-title lf">开标报表</p>
          <div class="rt">
            <template v-if="role != 'Z'">
              <el-button type="primary" @click="getKpdjgb" v-if="sfykpdjgb"
                >显示开评定结果表</el-button
              >
            </template>
            <template  v-if="role == 'Z'">
              <el-button
                type="primary"
                @click="kqqr"
                :disabled="sfszqrsj"
                >开启确认
              </el-button>
              <el-button
                type="primary"
                @click="scBb"
                :disabled="waitLoading"
                >生成报表
              </el-button>
            </template>
            <el-popover
              placement="bottom"
              popper-class="kbbbPop"
              v-model="showBtns"
              :disabled="!isScbb"
            >
              <ul class="loadBtns" v-if="wjList && wjList.length">
                <li
                  v-for="item in wjList"
                  :key="item.id"
                  @click="loadBb(item.id)"
                >
                  {{ item.wjmc }}
                </li>
              </ul>
              <el-button
                :class="{ show: isScbb && !waitLoading }"
                slot="reference"
                :disabled="waitLoading"
                >下载</el-button
              >
            </el-popover>
          </div>
        </div>
        <p v-if="role == 'Z'" class='numP' style="margin-top:200px">
          <template v-if='!sfszqrsj'>唱标已结束，请开启确认</template>
          <template v-else>投标单位确认已结束，请生成报表</template>
        </p>
        <p v-else class='numP' style="margin-top:200px">
          唱标已结束
        </p>

        <el-button
          type="primary lcNext"
          :disabled="!isScbb || waitLoading"
          @click="nextBtn"
          v-if="kbxmlc.zt != '2' && role == 'Z'"
          >下一步</el-button
        >
      </div>
    </template>
    <!-- 设置时间 -->
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="550px"
      :close-on-click-modal="false"
    >
      <div class="dialogBox">
        <div>
          <span>设置开标结果确认时间</span>
          <el-input
            type="number"
            v-model.number="time"
            style="width: 120px"
          ></el-input>
          分钟
        </div>
      </div>
      <div class="btnBox">
        <el-button type="primary" @click="saveTime" :disabled="waitLoading"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 开评定弹窗 -->
    <el-dialog
      title="报表"
      :visible.sync="bbVisible"
      :close-on-click-modal="false"
      :fullscreen="true"
    >
      <div class="pdf">
        <iframe
          :src="kpdjgbPdf"
          frameborder="0"
          width="100%"
          height="100%"
        ></iframe>
      </div>
      <div class="btnBox">
        <el-button
          type="primary"
          @click="kpdjgbTbr"
          :disabled="sfkpdjgbtbr"
          v-if="role == 'A' || role == 'T'"
          >{{ sfkpdjgbtbr ? "已推送" : "推送投标人" }}</el-button
        >
        <el-button type="primary" @click="bbVisible = false">关闭</el-button>
        <el-button type="primary" @click="loadKpdjgb">下载</el-button>
        <!-- <el-button type="primary" @click="loadKpdjgb">抽签</el-button> -->
      </div>
    </el-dialog>
  </div>
  <div v-else class="loading">
    <p>页面正在加载中...</p>
    <div id="colorfulPulse">
      <span class="item-1"></span>
      <span class="item-2"></span>
      <span class="item-3"></span>
      <span class="item-4"></span>
      <span class="item-5"></span>
      <span class="item-6"></span>
      <span class="item-7"></span>
    </div>
  </div>
</template>
<script>
import myClock from "../components/clock/clock";

export default {
  name: "kbbb",
  components: {myClock},
  data() {
    return {
      waitLoading: false,
      kbxmlc: "",
      djlcId: "", //当前节点状态
      tableHead: {},
      tableData: [],
      wjList: [],
      yqr: 0,
      tbdwmc: "",
      isScbb: false, //是否已生成报表
      showBtns: false, //是否显示生成报表操作
      sfykpdjgb: false, //是否显示开评定结果按钮
      sfkpdjgbtbr: false, //是否开启过显示开评定结果按钮
      dialogVisible: false,
      time: 5,
      qrjssj:null,//确认结束时间
      intervalKbbb: null,
      sfszqrsj: false,
      role: localStorage.getItem("role") ? localStorage.getItem("role") : "T",
      bbVisible: false,
      kpdjgbPdf: "",
      pdfId: "",
      lcSteps: JSON.parse(
        localStorage.getItem("lcSteps") ? localStorage.getItem("lcSteps") : ""
      ),
      aaa: false,
      
    };
  },
  created() {
    this.aaa = this.lcSteps.some((item) => {
      return item.ycmc.includes("多次报价");
    });
    console.log('2222')
  },
  methods: {
    getData() {
      let para = {
        tbdwmc: this.tbdwmc,
        djlcId: this.djlcId,
        loginRole:this.role
      };
      this.waitLoading = true;
      clearInterval(this.intervalKbbb);
      this.intervalKbbb = null;
      this.qrjssj=null,
      this.$api
        .getkbbbData(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.tableHead = res.data.data.bjxsmc;
            this.kbxmlc = res.data.data.kbxmlc;
            this.total = res.data.data.data.total;
            this.yqr = res.data.data.data.yqrSize;
            this.sfykpdjgb = res.data.data.sfykpdjgb;
            this.sfkpdjgbtbr = res.data.data.kbxm.kpdjgbtbr == 0 ? false : true;
            if (res.data.data.tbdwMap) {
              var arr = res.data.data.data.tbdwList;
              arr.forEach((item, index) => {
                for (let key in res.data.data.tbdwMap[item.id]) {
                  item[key] = res.data.data.tbdwMap[item.id][key];
                }
              });
              this.tableData = arr;
            } else {
              this.tableData = res.data.data.data.tbdwList;
            }
            if (res.data.data.sfscwj) {
              this.isScbb = true;
              this.wjList = res.data.data.zhwjList;
            }
            if (res.data.data.sfszqrsj !== "") {
              this.sfszqrsj = true;
              var djs = res.data.data.sfszqrsj;
              if (djs >= 1000) {
                this.qrjssj=djs
                this.kbbbshenyuFun(djs);
              } else {
                clearInterval(this.intervalKbbb);
                this.intervalKbbb = null;
              }
            }
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //打开开评定结果弹窗
    getKpdjgb() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .getKpdjgb(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.bbVisible = true;
            this.kpdjgbPdf = res.data.data.pdfFile;
            this.pdfId = res.data.data.id;
            console.log("res", res);
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    loadKpdjgb() {
      let para = {
        id: this.pdfId,
      };
      this.waitLoading = true;
      this.$api
        .loadKpdjgb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //开启确认
    kqqr() {
      this.dialogVisible = true;
      this.time = 5;
    },
    //保存时间
    saveTime() {
      let para = {
        qrsj: Number(this.time),
      };
      this.waitLoading = true;
      this.$api
        .saveKqqrTime(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.dialogVisible = false;
            this.$message({
              type: "success",
              message: "保存成功！",
            });
            this.getData();
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    //生成报表
    scBb() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .scbb(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "报表生成成功！",
            });
            this.isScbb = true;
            this.wjList = res.data.data.zhwjList;
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch((err) => {
          this.$message({
              type: "error",
              message: err.data.meta.message,
            });
          this.waitLoading = false;
        });
    },
    //下载报表
    loadBb(id) {
      if (this.waitLoading) return false;
      let para = {
        id: id,
      };
      this.waitLoading = true;
      this.$api
        .loadBb(para)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );
          let blob = new Blob([res.data]);
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = fileName;
            link.click();
            //释放内存
            window.URL.revokeObjectURL(link.href);
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
    nextBtn() {
      let para = {
        flag: this.kbxmlc.ycdz,
      };
      this.waitLoading = true;
      this.$emit("nextBtn", para);
    },
    //计算剩余时间倒计时
    kbbbshenyuFun(djs) {
      var _this = this;
      var time = Number(djs);
      var flag = false;
      _this.intervalKbbb = setInterval(function () {
        if (time < 1000) {
          clearInterval(_this.intervalKbbb);
          _this.intervalKbbb = null;
          if (!flag) {
            flag = true;
            _this.getData();
          }
          return;
        }
        time = time - 1000;
      }, 1000);
    },
    kpdjgbTbr() {
      let para = {};
      this.waitLoading = true;
      this.$api
        .kpdjgbTbr(para)
        .then((res) => {
          if (res.data.meta.success) {
            this.$message({
              type: "success",
              message: "推送投保人成功！",
            });
            this.sfkpdjgbtbr = true;
            let obj = {
              lx: "zb",
              data: {
                id: "",
              },
            };
            this.$emit("send", JSON.stringify(obj));
          } else {
            this.$message({
              type: "error",
              message: res.data.meta.message,
            });
          }
          this.waitLoading = false;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.djlcId = this.$route.query.djlcId;
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.intervalKbbb);
    this.intervalKbbb = null;
  },
};
</script>
<style lang="less">
.kbbb {
  .dialogBox {
    padding: 50px 80px;
    span {
      font-size: 16px;
      color: #333;
      margin-right: 10px;
    }
    .el-input__inner {
      padding: 0 0 0 15px;
    }
  }
  span > .el-button.show {
    margin-left: 10px;
    background: @base-color;
    color: #fff;
  }
  span > .el-button.show:hover,
  span > .el-button.show:focus {
    background: fade(@base-color, 80%);
    color: #fff;
  }
  span > .el-button,
  span > .el-button:hover,
  span > .el-button:focus {
    background: #ccc;
    margin-left: 10px;
    color: #fff;
  }
  .el-button--primary.is-disabled.djsBtn {
    color: #d70a30;
    font-size: 18px;
  }
    .numP{
    font-size: 28px;
    color:#333;
    text-align: center;
    font-weight: bold;
  }
}
.el-popover.kbbbPop {
  min-width: 100px;
  padding: 0px;
  border: 1px solid @base-color;
  background: @bg;
  .loadBtns {
    li {
      list-style: none;
      height: 35px;
      line-height: 35px;
      color: @base-color;
      padding: 0 12px;
      cursor: pointer;
    }
    li + li {
      border-top: 1px solid @base-color;
    }
  }
}

.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow {
  border-bottom-color: @base-color;
}
.el-popper[x-placement^="bottom"].kbbbPop .popper__arrow::after {
  border-bottom-color: @bg;
}
.el-dialog__body {
  height: 100%;
  .pdf {
    height: calc(~"100% - 60px");
    margin-bottom: 10px;
  }
}
.bjBtn{
    border: 1px solid rgba(0, 96, 178, 0.1);
    border-top: 2px solid #0060b2;
    text-align: center;
    height: calc(100% - 60px);
    padding-top: 120px;
    position: relative;
    .clear{
      height: 420px;
    }
  .clockBox{
    width: 890px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    p.time{
      font-size: 20px;
      color: #2D2D2D;
      line-height: 50px;
    }
  }
}
</style>